/**
 * Stable lookup key for a course offering product (offering + optional campus).
 * Kept separate from the cached data loader so client components can import it.
 */
export function courseOfferingProductKey(
	courseOfferingId: string,
	campusId: string | null
): string {
	return `${courseOfferingId}::${campusId ?? ""}`;
}
